










































































































































import Vue from 'vue'
import { $, generateUUID, sleep, uaIsIOS, loadmetadataVideo } from '@/utils/helpers'
import { loadImage } from '@/utils/ImageUtil'

interface StampItem {
  sid: string
  img: string
}

export default Vue.extend({
  name: 'ChatForm',
  props: {
    applyEvent: {
      type: String,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    useChatMenu: {
      type: Boolean,
      default: false
    },
    useStamp: {
      type: Boolean,
      defualt: false
    },
    progressMax: {
      type: Number,
      default: null
    },
    progressValue: {
      type: Number,
      default: null
    },
    value: {
      type: String,
      required: true
    },
    maxlength: {
      type: Number,
      default: null
    },
    defaultPlaceholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formHeight: 0,
      imageFiles: [],
      imageURL: '',
      isFocusTextArea: false,
      isShowChatMenu: false,
      isShowStamp: false,
      MEDIATYPE_ALLMEDIA: -1,
      MEDIATYPE_VIDEO: -1,
      message: '',
      PICTURESOURCETYPE_CAMERA: -1,
      PICTURESOURCETYPE_PHOTOLIBRARY: -1,
      nativeFileData: null,
      upFile: null,
      videoFiles: [],
      videoURL: '',
      videoThumbnail: '',
      isLoading: false,
      stampStatus: {},
      selectedStampItem: null,
      selectedStampTab: 0,
      preloadedImages: []
    }
  },
  computed: {
    chatMenuIcon(): string {
      return this.isShowChatMenu ? 'keyboard' : 'plus'
    },

    stampIcon(): string {
      return this.isShowStamp ? 'keyboard' : 'happy-face'
    },

    /**
     * スタンプ一覧
     */
    stamps(): any[] {
      return this.useStamp ? this.$store.getters['Stamp/stamps'] : []
    },

    /**
     * スタンプのタブ画像
     */
    stampTabImages(): string[] {
      return (
        this.stamps
          .map(elem => {
            return elem.tab_img
          })
          // 0番目の要素は履歴用のタブなので不要
          .slice(1)
      )
    },
    /**
     * 選択したスタンプ画像の L サイズ
     */
    selectedStampImgL(): string {
      return this.selectedStampItem ? this.selectedStampItem.img.replace(/_s\.png/, '.png') : ''
    },

    // Web の iOS Safari のみ fixled: bottom のキーボードが隠れるので対策
    chatFormStyle(): string {
      if (!this.$_hasCordova && uaIsIOS && this.isFocusTextArea) {
        return `padding-bottom: 44px;`
      } else {
        return ''
      }
    },

    selectedFile(): boolean {
      return this.nativeFileData || this.imageURL || this.videoURL
    },

    placeholder(): string {
      if (this.selectedFile) {
        return 'ファイルを送信'
      } else if (this.isShowStamp) {
        return 'スタンプを送信'
      }
      return this.defaultPlaceholder
    },

    /**
     * textarea の改行に合わせて行を autosize する
     */
    rows(): number {
      if (this.message) {
        const num = this.message.split('\n').length
        return num <= 3 ? num : 3
      }
      return 1
    },

    isVisibleStampBox(): boolean {
      return this.stamps.length > 0
    }
  },
  watch: {
    /**
     * テンプレートの自動入力など mounted 後に更新される値も反映する
     */
    value(val: string) {
      this.message = this.value
    },

    /**
     * offsetHeight が更新されたら親に通知
     */
    async rows() {
      await this.$nextTick()
      this.emitOffsetHeight()
    },

    isShowStamp(val) {
      this.$emit('toggleStamp', val)
    }
  },
  created() {
    if (this.$_hasCordova) {
      this.MEDIATYPE_ALLMEDIA = Camera.MediaType.ALLMEDIA
      this.MEDIATYPE_VIDEO = Camera.MediaType.VIDEO
      this.PICTURESOURCETYPE_PHOTOLIBRARY = Camera.PictureSourceType.PHOTOLIBRARY
      this.PICTURESOURCETYPE_CAMERA = Camera.PictureSourceType.CAMERA
    }

    if (this.useStamp) {
      this.fetchStamps()
    }
  },
  mounted() {
    this.message = this.value
    this.emitOffsetHeight()
  },
  methods: {
    /**
     * $el の offsetHeight を取得して親コンポーネントに emit
     */
    emitOffsetHeight(add?: number) {
      if (add) {
        this.formHeight += add
      }
      this.formHeight = this.$el['offsetHeight']
      this.$emit('changeFormHeight', this.formHeight)
    },

    /**
     * チャットメニューの表示をトグルする
     */
    toggleChatMenu() {
      this.closeStampPreview()
      if (this.isShowStamp) {
        this.isShowStamp = false
      }
      this.isShowChatMenu = !this.isShowChatMenu

      if (!this.isShowChatMenu) {
        this.focusKeyboard()
      }
    },

    /**
     * スタンプメニューの表示をトグルする
     */
    toggleStamp() {
      this.closeStampPreview()
      if (this.isShowChatMenu) {
        this.isShowChatMenu = false
      }
      this.isShowStamp = !this.isShowStamp

      if (!this.isShowStamp) {
        this.focusKeyboard()
      }
    },

    /**
     * キーボードをフォーカスして表示する
     */
    focusKeyboard() {
      this.$nextTick().then(() => {
        // textarea にフォーカスを移してキーボードを表示する
        this.$refs.textarea['focus']()
      })
    },

    /**
     * スタンプを表示するならチャットメニューを非表示にする
     */
    hideChatMenu() {
      this.isShowChatMenu = false
    },

    /**
     * スタンプメニューを非表示にする
     */
    hideStamp() {
      if (this.selectedStampItem) {
        this.closeStampPreview()
      }
      this.isShowStamp = false
    },

    /**
     * Native 機能を使って画像を取得
     */
    async getPictureWithNative(sourceType: number) {
      if (!this.$_hasCordova) {
        return
      }
      const options: CameraOptions = {}
      options.destinationType = Camera.DestinationType.FILE_URI
      options.sourceType = sourceType
      options.quality = 50
      options.correctOrientation = true
      try {
        this.nativeFileData = await this.$_getPicture(options)
        this.submit()
        this.hideChatMenu()
      } catch (err) {
        console.error(err)
      }
    },

    /**
     * input file から画像を選択
     */
    getPictureWithWeb(files?: File[]) {
      this.clearPreviewDatas()
      if (!files || files.length === 0) {
        return
      }
      this.upFile = Array.isArray(files) ? files[0] : files
      this.imageURL = URL.createObjectURL(this.upFile)
      this.submit()
      this.hideChatMenu()
    },

    /**
     * input file から動画を選択
     */
    selectVideoWithWeb(files?: File[]) {
      this.clearPreviewDatas()
      if (!files || files.length === 0) {
        return
      }
      this.upFile = Array.isArray(files) ? files[0] : files
      this.videoURL = URL.createObjectURL(this.upFile)
      this.submit()
      this.hideChatMenu()
    },

    /**
     * Native 機能を使って動画を取得
     */
    async getVideoWithNative(sourceType: number) {
      if (!this.$_hasCordova) {
        return
      }
      this.isLoading = true

      try {
        let originalVideoWidth = null
        let originalVideoHeight = null
        if (sourceType === Camera.PictureSourceType.CAMERA) {
          const mediaFile: MediaFile = await this.$_caputureVideo()
          const mediaFileData = await this.$_getCaptureVideoMediaFileData(mediaFile)
          originalVideoWidth = mediaFileData.width
          originalVideoHeight = mediaFileData.height
          this.nativeFileData = mediaFile.fullPath
        } else {
          const options: CameraOptions = {
            destinationType: Camera.DestinationType.FILE_URI,
            mediaType: Camera.MediaType.VIDEO,
            quality: 50,
            sourceType: sourceType,
            correctOrientation: true
          }
          this.nativeFileData = await this.$_getPicture(options)
          let video: HTMLVideoElement = await loadmetadataVideo(this.nativeFileData)
          originalVideoWidth = video.videoWidth
          originalVideoHeight = video.videoHeight
          video = null
        }

        if (
          this.$_platformIsAndroid &&
          !new RegExp(location.protocol + '//').test(this.nativeFileData)
        ) {
          this.nativeFileData = location.protocol + '//' + this.nativeFileData
        }

        // オリジナルファイルが 1080 を超えているときだけ圧縮
        const shouldCompression = originalVideoWidth >= 1080 || originalVideoHeight >= 1080
        if (shouldCompression) {
          const transcodeVideoOptions = {
            fileUri: this.nativeFileData,
            outputFileName: generateUUID(),
            outputFileType: VideoEditorOptions.OutputFileType.MPEG4,
            optimizeForNetworkUse: VideoEditorOptions.OptimizeForNetworkUse.NO,
            saveToLibrary: false,
            deleteInputFile: false,
            maintainAspectRatio: true,
            width: originalVideoWidth * 0.5,
            height: originalVideoHeight * 0.5,
            videoBitrate: 1397000,
            fps: 30,
            audioChannels: 2,
            audioSampleRate: 48000,
            audioBitrate: 64000,
            progress: value => {
              if (value >= 100) {
                this.isLoading = false
              }
            }
          }
          this.nativeFileData = await this.$_transcodeVideo(transcodeVideoOptions)
        }

        this.submit()
        this.hideChatMenu()
      } catch (err) {
        console.error(err)
        // 選択しなかった場合は何もしない
        if (
          err === 'No Image Selected' ||
          err === 'has no access to assets' ||
          (err.code && err.code === 3)
        ) {
          return
        }
        this.$_alert('動画圧縮失敗')
      } finally {
        this.isLoading = false
      }
    },

    /**
     * preview 用のデータをクリア
     */
    clearPreviewDatas() {
      this.nativeFileData = null
      if (this.imageURL) {
        this.clearImageData()
      }
      if (this.videoURL) {
        this.clearVideoData()
      }
    },

    clearImageData() {
      URL.revokeObjectURL(this.imageURL)
      this.upFile = null
      this.imageURL = ''
      for (let i = 0; i < this.imageFiles.length; i++) {
        this.imageFiles[i] = null
      }
      this.imageFiles = []
    },

    clearVideoData() {
      URL.revokeObjectURL(this.videoURL)
      URL.revokeObjectURL(this.videoThumbnail)
      this.upFile = null
      this.videoURL = ''
      this.videoThumbnail = ''
      for (let i = 0; i < this.videoFiles.length; i++) {
        this.videoFiles[i] = null
      }
      this.videoFiles = []
    },

    /**
     * メッセージの送信
     */
    async submit() {
      if (this.$_platformIsIOS) {
        // iOS では textarea フォーカス中にメッセージを送信するとメッセージが送信後も空にならない
        this.$refs.textarea['blur']()
        await sleep(100)
      }

      const entry: ChatSubmitOptions = {}
      entry.text = this.message
      entry.upFile = this.upFile
      entry.nativeFileData = this.nativeFileData

      if (this.useStamp && this.selectedStampItem) {
        entry.stamp = this.selectedStampImgL
        entry.sid = this.selectedStampItem.sid

        // 履歴に反映
        this.$store.dispatch('Stamp/unshiftStampLogItem', this.selectedStampItem)
      }

      if (this.$_hasCordova && entry.nativeFileData) {
        try {
          entry.mimeType = await this.$_nativePathToFileType(this.nativeFileData)
        } catch (err) {
          console.error(err)
        }
      }

      this.message = ''
      this.upFile = null
      this.nativeFileData = null
      this.isShowChatMenu = false
      this.isShowStamp = false
      this.selectedStampItem = null
      this.stampStatus = {}
      this.$emit(this.applyEvent, entry)
    },

    /**
     * 動画のサムネイルを生成
     */
    async createVideoThumbnail() {
      let video: HTMLVideoElement = $('.ChatForm__preview-video')
      // iOS で動画を撮影した場合は play() 前に sleep が必要
      if (uaIsIOS) {
        await sleep(100)
      }
      // 一度再生しないとサムネイルが取得できない
      video.play()
      await sleep(100)
      video.pause()

      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      canvas.width = video.scrollWidth
      canvas.height = video.scrollHeight
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      this.videoThumbnail = canvas.toDataURL('image/jpeg')
      ctx = null
      canvas = null
      video = null
    },

    /**
     * iOS 12.2 で textarea をタップしてもフォーカスしないことがあるので保険として
     */
    handleTextareaClick(event) {
      event.target.focus()
    },

    /**
     * Focus textarea
     */
    onFocus() {
      this.isFocusTextArea = true
    },

    /**
     * Blur textarea
     */
    onBlur() {
      this.isFocusTextArea = false
    },

    /**
     * 親の v-model を発火させる
     */
    onInput(event) {
      this.$emit('input', event.target.value)
    },

    /**
     * スタンプを選択
     */
    handleStampClick(item: StampItem, key: number) {
      if (this.stampStatus[key]) {
        // 選択状態でもう一度同じスタンプをタップしたら送信
        this.submit()
        this.stampStatus = {}
      } else {
        this.stampStatus = {}
        this.stampStatus[key] = true
        this.selectedStampItem = item
      }
    },

    /**
     * スタンプタブをクリック
     */
    handleStampTabClick(index: number) {
      if (!this.preloadedImages[index]) {
        // 画像の事前読み込み
        const items = this.stamps[index].items
        const keys = Object.keys(items)
        for (let i = 0; i < keys.length; i++) {
          loadImage({ src: items[keys[i]].img })
        }
        this.preloadedImages[index] = true
      }
      this.selectedStampTab = index
    },

    /**
     * スタンプをサーバから fetch する
     */
    fetchStamps() {
      this.$store.dispatch('Stamp/fetchStamps')
    },

    /**
     * スタンププレビューを閉じる
     */
    closeStampPreview() {
      this.stampStatus = {}
      this.selectedStampItem = null
    },

    /**
     * スタンプ表示中はスクロール禁止
     */
    stopScroll(event: Event) {
      if (!this.isShowStamp) return
      event.preventDefault()
    }
  }
})
